import { Component, Input,Output,EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtlGenDropBoxListeKontrolService } from './ctl-gen-drop-box-liste-kontrol.service';
import { OrtakService, UtilsService} from '@dabnet-kamu/libs/ui';
import { DxDropDownBoxModule, DxListModule, DxTextBoxModule,DxValidatorComponent,
  DxValidatorModule, } from 'devextreme-angular';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';

@Component({
  selector: 'dk-ctl-gen-drop-box-liste-kontrol',
  standalone: true,
  imports: [CommonModule,DxDropDownBoxModule,DxListModule,DxTextBoxModule,DxiValidationRuleModule,    DxValidatorModule,],
  templateUrl: './ctl-gen-drop-box-liste-kontrol.component.html',
  styleUrls: ['./ctl-gen-drop-box-liste-kontrol.component.scss'],
})
export class CtlGenDropBoxListeKontrolComponent {
  @ViewChild(DxValidatorComponent, {static: false}) validator: DxValidatorComponent;
  dataSources: any;
  secilenData: any = null;
  isOpen:boolean = false;
  control:any;
  private debounceTimer: any;
  @Input() controlName:any;
  @Input() label:any;
  @Input() isShowAccordion:any;
  @Input() value:any;
  @Input() valueExpr:any;
  @Input() readOnly:any;
  @Output() getSelectItem:EventEmitter<string>=new EventEmitter<string>();
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() customQuery: any;
  
  constructor(private service: CtlGenDropBoxListeKontrolService, private utilService: UtilsService,private ortakService: OrtakService) {

  }
  validationRul: any[];


debounce(func: Function, delay: number = 100) {
  clearTimeout(this.debounceTimer);
  this.debounceTimer = setTimeout(() => {
    func();
  }, delay);
}

 ngOnChanges(changes: SimpleChanges) {
    //this.validationRules= [{type:'required', message:'Bu alan zorunludur.'}]
    if (changes['validationRulesMap']) {
      this.applyValidationRules();
    }
  }

  applyValidationRules() {
    // if(this.validationRulesMap[0]?.type === 'required') {
    //   return this.validationRules = [{type: 'required', message: 'Bu alan zorunludur.'}]
    // }else{ return null}
    this.validationRulesMap?.map(res => {
      if (res.type === 'required') {
        return this.validationRulesMap = [{type: 'required', message: 'Bu alan zorunludur.'}]
      } else {
        return null
      }
    })
  }

onDropdownOpened(){
  this.isOpen = true;
}
onDropdownClosed(){
  this.isOpen = false;
}

onAutoCompleteValueChanged($event: any) {
  this.debounce(() => this.getList($event));
}

ngOnInit():void{
  this.getControl()
}

getControl(){
  this.ortakService.getControl(this.controlName)
  .subscribe((data) => {
    this.control = data?.controlMetadata;
    this.control.searchColumns = this.control.searchColumns
    .split(',')
    .slice(1)
    .join(',');
    Promise.all([
      this.service.getFilter([this.valueExpr, '=', this.value], this.control?.dlistMetadata?.baseEntity, this.customQuery),
      this.service.getFilter([this.valueExpr, '<>', this.value], this.control?.dlistMetadata?.baseEntity, this.customQuery + '&take=9'),
    ]).then(([exactMatchRes, othersRes]) => {
      const combined = [
        ...(exactMatchRes ?? []),
        ...(othersRes ?? []),
      ];
    
      this.dataSources = combined.map((item: any) => {
        const display = this.control.descriptionField.split(',').map((col: string) =>
          item[col] != null ? item[col] : null
        ).join(', ');
    
        return {
          ...item,
          display,
        };
      });
    });
  });

}
searchDebounce($event: any) {
  this.debounce(() => this.searchValue($event), 500);
}
async searchValue($event: any) {
  const inputValue = ($event.value || '').trim();
  console.log(inputValue, "searched keyup");

  if (inputValue.length === 0) {
    // Arama kutusu boşsa tekrar başlangıç verilerini yükle
    await this.getControl();
    return;
  }

  const input = inputValue.replace(/Kod/g, '').trim();

  const filters = this.generateFiltersFromInput(input, this.control.searchColumns.split(','));

  await this.service.getFilter(filters, this.control?.dlistMetadata?.baseEntity, this.customQuery)
    .then((resFilter) => {
      if (resFilter) {
        this.dataSources = resFilter.map((item: any) => {
          const display = this.control.descriptionField.split(',')
            .map((col: string) => item[col] != null ? item[col] : null)
            .join(', ');

          return {
            ...item,
            display
          };
        });
      }
    })
    .catch((err) => this.utilService.showError(err));
}


async getList($event: any) {
  const selectedItem = $event.itemData  ? $event.itemData  :null;
  if (selectedItem) {
    // Dinamik display oluştur
    const display = this.control.descriptionField.split(',')
    .map((col: string) => {
      if (selectedItem[col] != null) {
        return selectedItem[col];
      } else {
        return null;
      }
    })
    .filter(Boolean)
    .join(', ');

    this.secilenData = {
      ...selectedItem,
      display
    };
    this.onDropdownClosed();
    this.isOpen = false;
    this.getSelectItem.emit(this.secilenData);
  }
  
}

generateFiltersFromInput(input: string, columns: string[]) {
  const value = input.trim();
  if (!value) return [];

  const words = value.split(/\s+/);
  const filters: any[] = [];

  words.forEach((word, wordIndex) => {
    const wordFilters: any[] = [];

    columns.forEach((col, colIndex) => {
      wordFilters.push([col, 'contains', word]);
      if (colIndex < columns.length - 1) {
        wordFilters.push('or');
      }
    });

    filters.push(wordFilters);

    if (wordIndex < words.length - 1) {
      filters.push('and');
    }
  });

  return filters;
}



}
